/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    InternalApiCustomListSignificantFields,
    InternalApiCustomListSignificantFieldsFromJSON,
    InternalApiCustomListSignificantFieldsToJSON,
    InternalApiEntityType,
    InternalApiEntityTypeFromJSON,
    InternalApiEntityTypeToJSON,
} from '../models';

export interface GetSignificantFieldsRequest {
    entityType: InternalApiEntityType;
}

export interface UpdateSignificantFieldsRequest {
    internalApiCustomListSignificantFields: InternalApiCustomListSignificantFields;
}

/**
 * 
 */
export class CustomListSignificantFieldApi extends runtime.BaseAPI {

    /**
     * Gets all custom list significant update indicators
     */
    async getSignificantFieldsRaw(requestParameters: GetSignificantFieldsRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalApiCustomListSignificantFields>> {
        if (requestParameters.entityType === null || requestParameters.entityType === undefined) {
            throw new runtime.RequiredError('entityType','Required parameter requestParameters.entityType was null or undefined when calling getSignificantFields.');
        }

        const queryParameters: any = {};

        if (requestParameters.entityType !== undefined) {
            queryParameters['entityType'] = requestParameters.entityType;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/custom-lists/significant-fields`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalApiCustomListSignificantFieldsFromJSON(jsonValue));
    }

    /**
     * Gets all custom list significant update indicators
     */
    async getSignificantFields(requestParameters: GetSignificantFieldsRequest, initOverrides?: RequestInit): Promise<InternalApiCustomListSignificantFields> {
        const response = await this.getSignificantFieldsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Updates custom list significant update indicators
     */
    async updateSignificantFieldsRaw(requestParameters: UpdateSignificantFieldsRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalApiCustomListSignificantFields>> {
        if (requestParameters.internalApiCustomListSignificantFields === null || requestParameters.internalApiCustomListSignificantFields === undefined) {
            throw new runtime.RequiredError('internalApiCustomListSignificantFields','Required parameter requestParameters.internalApiCustomListSignificantFields was null or undefined when calling updateSignificantFields.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/custom-lists/significant-fields`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: InternalApiCustomListSignificantFieldsToJSON(requestParameters.internalApiCustomListSignificantFields),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalApiCustomListSignificantFieldsFromJSON(jsonValue));
    }

    /**
     * Updates custom list significant update indicators
     */
    async updateSignificantFields(requestParameters: UpdateSignificantFieldsRequest, initOverrides?: RequestInit): Promise<InternalApiCustomListSignificantFields> {
        const response = await this.updateSignificantFieldsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
